import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "9", cy: "12", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "9", cy: "5", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "9", cy: "19", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "15", cy: "12", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "15", cy: "5", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "15", cy: "19", r: "1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "GripVertical";
const GripVertical = memo(themed(Icon));
export {
  GripVertical
};
//# sourceMappingURL=grip-vertical.js.map
